import z from 'zod'
import {
  nullSafeFirestoreTimestamp,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  institutionName: z.string(),
  ltiPayloadIssues: z
    .record(
      z.string(),
      z.object({
        type: z.string(),
        deploymentId: z.string(),
        problems: z.array(z.string()),
        // when the problems were last (re)detected on a launch
        updatedAt: nullSafeOptionalFirestoreTimestamp(),
        // per-organization last-notified timestamps (organizationId -> time),
        // the notification throttle key. Kept per org so one organization's
        // delivery outcome never throttles another; cleared when a clean launch
        // removes the entry.
        notifiedOrgs: z
          .record(z.string(), nullSafeOptionalFirestoreTimestamp())
          .optional(),
      })
    )
    .optional(),
  updatedAt: nullSafeFirestoreTimestamp(),
})

export const writeSchema = schema.extend({})

export const empty = Object.freeze(
  schema.parse({
    institutionName: '',
  })
)

export type FirestoreInstitution = z.infer<typeof schema>
